import { type FC, Fragment } from 'react';

import { useTranslation } from '@crehana/i18n';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Slider } from '@crehana/ui';

import type { GetSkillXQResults_skillsB2BUserResult_resultSkill_recommendedCourses as CourseType } from '@/views/B2BSkillXP/graphql/types/GetSkillXQResults';

import CourseCard from '../../../../components/CourseCard';

interface RecommendedCoursesProps {
  courses: CourseType[];
}

const RecommendedCourses: FC<
  React.PropsWithChildren<RecommendedCoursesProps>
> = ({ courses }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <div>
        <p className="font-h3 text-white sm:w-10/12 md:w-8/12 lg:w-full mb-12">
          {t('RECOMMENDED_COURSES_TITLE')}
        </p>
        <p className="font-body1 text-white">
          {t('RECOMMENDED_COURSES_SUBTITLE')}
        </p>
      </div>
      <div className="flex justify-end my-16">
        <div className="default-pagination-features" />
      </div>
      <Slider
        dark
        desktopPaginationSelector=".default-pagination-features"
        itemsPerPage={{
          lg: 4,
          md: 3,
          sm: 2,
          xs: 1,
        }}
      >
        {courses.map(course => (
          <CourseCard key={course?.originalId} course={course} />
        ))}
      </Slider>
    </Fragment>
  );
};

export default RecommendedCourses;
